module.exports = __webpack_public_path__ + "media/images/beaute mains pieds-aef3ae14ca07211e126932035e0c98a2.svg";